export const errorsAuthService = {
  EAT0005: 'Credenciais invalidas',
  EAT0006: 'Muitas tentativas de login invalidas. Por favor mude sua senha.'
}
